import React from "react";
import PropTypes from "prop-types";

import { ButtonElement, Icone } from "./Button.styles";

const Button = props => {
  return (
    <ButtonElement {...props}>
      {props.src && <Icone src={props.src} marginLeftImg={props.marginLeftImg} />}

      <p>{props.text}</p>
    </ButtonElement>
  );
};

Button.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthPercent: PropTypes.string,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  text: PropTypes.string.isRequired,
  marginTop: PropTypes.number,
  marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginLeftText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  border: PropTypes.bool,
  borderColor: PropTypes.string,
  src: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  letterSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textDecoration: PropTypes.string,
  marginLeftImg: PropTypes.number,
};

Button.defaultProps = {
  width: "212",
  widthPercent: undefined,
  height: undefined,
  backgroundColor: "#E3252E",
  textColor: "white",
  marginTop: 12,
  marginLeft: 1,
  marginBottom: 0,
  marginLeftText: undefined,
  src: undefined,
  border: false,
  borderColor: undefined,
  disabled: false,
  fontWeight: "normal",
  letterSpacing: "normal",
  lineHeight: "normal",
  borderRadius: undefined,
  zIndex: undefined,
  textDecoration: undefined,
  marginLeftImg: 18,
};

export default Button;
